module.exports = __webpack_public_path__ + "files/93abf975b492c1db2a33d571171e5c4a.svg";